<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Standardansicht wählen"}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-md-12" id="modal-body">
			{{#if errors.error}}
			<div class="alert alert-danger">{{TR errors.error }}</div>
			{{/if}}

			<div class="form-group">
				<label for="{{el_id}}" class="control-label">{{label}}</label>

		                {{#SELECT version}}
				<select class="form-control select2" id="{{el_id}}-input" name="{{el_id}}">
					{{#each dropdownItems}}
					<option value="{{this.key}}">{{this.value}}</option>
					{{/each}}
				</select>
				{{/SELECT}}
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
